module.exports = window["core-js/modules/es.string.link.js"];